export default {
    common: {
        meta: {
            title: 'CrispyVoice',
            subTitle: 'The voice of your future'
        },
        mediums: {
            commercials: {
                title: 'Commercials',
                examples: 'TV, Billboards, YouTube and Radio'
            },
            'info-videos': {
                title: 'Info Videos',
                examples: 'E-Learning, Product video, Image video'
            },
            'social-media': {
                title: 'Social Media',
                examples: 'Facebook, YouTube, Instagram, TikTok'
            },
            public: {
                title: 'Public',
                examples: 'Fire alarm, PA, Shooter alarm'
            }
        },
        buttons: {
            cancel: 'Cancel',
            back: 'Back',
            submit: 'Submit'
        },
        errors: {
            somethingWentWrong: 'Something went wrong!'
        },
        formats: {
            mp3: 'MP3',
            wav: 'WAV'
        },
        timeframes: {
            day_one: 'day',
            day_other: 'days',
            week_one: 'week',
            week_other: 'weeks',
            month_one: 'month',
            month_other: 'months',
            year_one: 'year',
            year_other: 'years'
        },
        'contact-speaker': 'Contact {{shortName}}'
    },
    account: {
        heading: 'Settings',
        language: 'Display language',
        save: 'Save',
        password: 'Password',
        'change-password': 'Change password',
        'current-password': 'Current password',
        'new-password': 'New password',
        'repeat-new-password': 'Repeat new password',
        'password-change-successful': 'Password changed successfully!',
        invoices: 'Invoices',
        'invoice-date': 'Date',
        'invoice-amount': 'Amount',
        'invoice-status': 'Status',
        'invoice-link': 'Invoice',
        'invoice-view': 'View',
        validation: {
            password: {
                currentRequired: 'Current password is required',
                repeatRequired: 'Please repeat your new password',
                mismatch: 'Passwords do not match',
                currentInvalid: 'Current password is incorrect'
            }
        }
    },
    hero: {
        testimonial:
            "I'm delighted with {{name}}'s AI voice for our internal projects and calculations, while using the natural voice for advertising and social media campaigns.",
        title: 'Your professional and legally protected AI voice.',
        subTitle:
            'Create your personalized text in minutes and download the audio file along with the release document after payment.'
    },
    'medium-selection': {
        header: 'Where do you want to use my voice?',
        'price-from': 'from {{currency}} {{basePrice}}',
        'included-characters': '{{included}} characters included',
        'price-additional-characters': '{{currency}} {{price}} / additional character',
        'unrestricted-usage': 'Perpetual license',
        'restricted-usage': '{{value}} $t(common:timeframes.{{unit}}, { "count": {{value}} }) license',
        api: {
            title: 'Interface',
            subTitle: 'upon request'
        }
    },
    'audio-generation': {
        header: 'Generate your text now!',
        'copy-protection-info': 'The crackling? Just a preview watermark. Your purchased file is crackle-free.',
        buttons: {
            generate: 'Generate',
            'please-wait': 'Please wait...',
            stop: 'Stop'
        },
        'text-placeholder': 'Enter your text here...',
        'recording-prefix': 'Recording',
        'take-prefix': 'Version',
        'available-languages': 'Available languages',
        'supported-languages':
            'We support 29 languages: English (USA, UK, Australia, Canada), Japanese, Chinese, German, Hindi, French (France, Canada), Korean, Portuguese (Brazil, Portugal), Italian, Spanish (Spain, Mexico), Indonesian, Dutch, Turkish, Filipino, Polish, Swedish, Bulgarian, Romanian, Arabic (Saudi Arabia, UAE), Czech, Greek, Finnish, Croatian, Malay, Slovak, Danish, Tamil, Ukrainian & Russian.'
    },
    checkout: {
        header: 'Choose one or multiple versions!',
        description:
            'Select your preferred audio versions by clicking the checkboxes next to each player. You can choose one or multiple versions to download. All selected versions will be available in your download package, allowing you to later combine or edit them using your own audio software. This flexibility enables you to create custom mixes and arrangements from the generated content.',
        'no-recordings-yet': 'Please generate a text first to see something here!',
        play: 'Play',
        stop: 'Stop',
        'accept-terms': 'Yes, I accept the <0>terms and conditions</0>.',
        'order-now': 'Order now',
        'allowed-medium_one': 'Allowed medium',
        'allowed-medium_other': 'Allowed mediums',
        format: 'Format',
        'including-release-document': 'Including release document',
        'download-after-payment': 'Download right after payment',
        columns: {
            version: 'Version',
            text: 'Text',
            play: 'Play',
            buy: 'Buy'
        },
        variants: 'variant',
        variants_other: 'variants',
        'line-item_zero': '{{speakerName}} - {{mediumTitle}}: {{textLength}} characters',
        'line-item':
            '{{speakerName}} - {{mediumTitle}}: {{textLength}} characters, incl. {{count}} $t(checkout:variants, { "count": {{count}} })'
    },
    footer: {
        gtc: 'Terms of use',
        imprint: 'Imprint',
        'contact-real-voice': 'Contact natural voice',
        copyright: '\u24B8 CrispyVoice {{year}}'
    },
    auth: {
        titles: {
            forgotPassword: 'Forgot password?',
            login: 'Login',
            register: 'Register',
            resetPassword: 'Reset password',
            verifyCode: 'Verify code'
        }
    },
    login: {
        meta: {
            title: 'Login',
            subTitle: 'CrispyVoice Customer Portal'
        },
        email: 'E-Mail address',
        password: 'Password',
        'remember-me': 'remember me',
        login: 'Login',
        signIn: 'Sign In',
        forgotPassword: 'Forgot your password?',
        createAnAccount: 'Create an account!',
        resetPassword: 'Reset password',
        backToLogin: 'Back to Login',
        checkYourEmail: 'Check your email',
        emailVerificationCodeSent: "We've sent you a code to verify your email address.",
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        check2faApp: 'Check your 2FA app',
        enter2faCode: 'Please enter your 2FA code to verify your identity.'
    },
    register: {
        heading: 'Register',
        subHeading: 'Leave your details and we will contact you to set up your access.',
        name: 'Name',
        namePlaceholder: 'John Doe',
        email: 'E-mail address',
        emailPlaceholder: 'name@company.com',
        company: 'Company',
        companyPlaceholder: 'Your company',
        message: 'Message',
        messagePlaceholder: 'Tell us briefly what you need and we will get back to you.',
        submit: 'Request registration',
        hint: 'We usually get back to you within 24 hours.',
        success: 'Thanks! We received your request and will contact you shortly.',
        voiceArtistsLink: 'Listen to our VoiceArtists',
        voiceArtistsPath: '/voice-artists',
        backToLogin: 'Back to Login'
    },
    onboarding: {
        emails: {
            welcome: {
                subject: 'Welcome to CrispyVoice!',
                heading: 'Welcome to CrispyVoice, {{user_name}}!',
                login: 'Login here'
            },
            password: {
                subject: 'CrispyVoice: Your Account Password',
                heading: 'CrispyVoice account password',
                'password-text': "Here's your initial account password:",
                login: 'Login here',
                'change-it': 'We highly suggest that you change it after the initial login.'
            },
            purchaseComplete: {
                subject: 'Voice Owner Approved: Your audio data is ready! 🎙️',
                heading: 'Hi {{user_name}},',
                intro: 'Ordered. Generated. Done!',
                download_one: 'Your professional AI audio file is waiting for you:',
                download_other: 'Your professional AI audio files are waiting for you:',
                click: 'Start download',
                'features-header': 'What you get:',
                features_one: [
                    'AI audio file (MP3, 128 kbit/s)',
                    'Invoice with order number',
                    'Release document for legally compliant use',
                    'Link valid for 12 months',
                ],
                features_other: [
                    'AI audio files (MP3, 128 kbit/s)',
                    'Invoice with order number',
                    'Release document for legally compliant use',
                    'Link valid for 12 months',
                ],
                outro: '<strong>Important</strong>: Save the link or download the file directly.<br/>Und bitte!',
                claimAccountIntro:
                    "If you don't have an account yet, you can create one using the following link. Just enter a password and you'll have an overview of all your purchases in the future.",
                claimAccount: 'Create account'
            }
        }
    },
    navigation: {
        title: 'CrispyVoice portal',
        subTitle: 'welcome',
        home: 'Home',
        purchases: 'Purchases'
    },
    contact: {},
    gtc: {
        heading: 'General Terms and Conditions (GTC) for Customers of Voice Artists on CrispyVoice',
        text: `# 1. Scope and Contracting Parties
1.1. These General Terms and Conditions (hereinafter "GTC") govern the contractual
relationship between me as a professional voice artist (hereinafter "Voice Artist") and
you as the end customer (hereinafter "Customer") who purchases my AI-cloned voice
through the CrispyVoice platform (hereinafter "Platform").  
1.2. The CrispyVoice Platform serves exclusively as a technical service provider and
intermediary between me and you. Your contractual partner is exclusively me as the
Voice Artist.  
1.3. By ordering an AI-generated audio file with my voice, you fully accept these GTC.
# 2. Service Description
2.1. As a Voice Artist, I offer the creation of audio files with my AI-cloned voice through
the Platform. The audio files are created based on the text you submit.  
2.2. The audio files are provided in MP3 format with 128 kbit/s in mono quality.  
2.3. After successful payment, you will receive a download link to the created audio file
as well as a unique identification code associated with this file.  
2.4. I reserve the right to reject texts that violate applicable law or contain ethically
objectionable content. The review is automated through AI systems of the Platform.  
# 3. Registration and Ordering Process
3.1. To use my AI voice through the Platform, free registration is required. You agree to
provide truthful information and to keep your access data confidential.  
3.2. The ordering process includes the following steps: a) Selection of my voice b)
Selection of the intended use and corresponding license c) Entry of the text to be
voiced d) Selection of the desired number of takes/versions e) Review and confirmation
of the order f) Payment g) Immediate download of the generated audio file  
3.3. You will receive access to the ordered audio file immediately after successful
payment. The contract is considered fulfilled at this point.
# 4. Prices and Payment Terms
4.1. The prices for the various intended uses are set by me as the Voice Artist and are
transparently displayed on the Platform.  
4.2. The base prices each include a certain set of characters characters. Additional charges as indicated on the
Platform apply for each additional character.  
4.3. When ordering multiple takes or versions of the same text, a percentage surcharge
is calculated. For text changes in additional takes, the license fee is charged twice if this
option was selected.  
4.4. The total price will be clearly displayed to you before the final order confirmation.  
4.5. Payment is made exclusively through the payment methods offered (credit card via
Stripe or TWINT). All payments are due immediately and will be collected in full before
the audio file is provided.  
4.6. Invoicing is done through Stripe, showing the applicable value-added tax (VAT) in the
Customer's country, provided that I as the Voice Artist am subject to VAT. For
international transactions, the VAT rate of the country in which the Customer is based
applies, if required by applicable tax regulations.  
4.7. For Customers based in the European Union: Upon providing a valid VAT
identification number, the invoice can be issued without VAT, provided that the legal
requirements for an intra-community service are met.  
# 5. License and Usage Rights
5.1. By purchasing an audio file, you receive from me as the Voice Artist a non-exclusive,
non-transferable right to use the AI-generated voice for the intended use selected
during the ordering process.  
5.2. The license duration is determined by me as the Voice Artist and is clearly displayed
for each usage type during the ordering process. The specific duration of your license is
documented in your order confirmation and may include: a) Limited time period (e.g., 1
year, 2 years) b) Perpetual license (unlimited in time) c) Custom license periods as
specifically stated  
5.3. The usage right is valid worldwide, unless otherwise specified by me during the
ordering process.  
5.4. You are not entitled to: a) Use the audio file for purposes other than those
purchased b) Transfer or sell the audio file to third parties c) Use the audio file for
training speech models or AI systems d) Modify or edit the audio file e) Use the audio
file for illegal, fraudulent, or defamatory purposes f) Continue using the audio file after
the license period has expired (for time-limited licenses)  
5.5. In case of violation of these provisions, the usage right automatically expires, and I
reserve the right to take legal action.  
5.6. If you wish to extend a time-limited license or modify the usage rights, you must
place a new order or contact me directly through the Platform.  
5.7. For commercial uses, you are responsible for maintaining records of when and how
the audio file was used to ensure compliance with the license duration.  
# 6. Identification of AI-generated Content
6.1. Each purchased audio file receives a unique identification code, which is included in
a release document and serves to uniquely identify the licensed file.  
6.2. You agree to comply with the applicable legal and platform-specific labeling
requirements for AI-generated content when using the audio file.  
6.3. If a platform or medium on which you use the audio file prescribes specific labeling
of AI-generated content, you are obligated to provide such labeling. The unique
identification code provided with the audio file can be used for this purpose.  
6.4. Upon request, I will provide you with confirmation that you have legally purchased
and licensed the audio file.
# 7. Warranty and Liability
7.1. As a Voice Artist, I do not guarantee the accuracy of the content of the texts you
submit.  
7.2. Complaints regarding the quality of AI-generated audio files are excluded. When
booking my natural voice, the amount already paid may be credited at my discretion.  
7.3. My liability as a Voice Artist is limited to intent and gross negligence. Liability for
slight negligence is excluded to the extent legally permissible.  
7.4. I am not liable for damages resulting from misuse or illegal use of the audio files by
you.  
7.5. You indemnify me as the Voice Artist from all claims by third parties that may arise
from your use of the audio files.  
7.6. The maximum liability is in any case limited to the purchase price paid by you.
# 8. Data Protection
8.1. Your personal data (company, address, phone number, email) will be collected and
processed exclusively for the purpose of contract execution and in accordance with
applicable data protection regulations.  
8.2. The data is stored on AWS and Hetzner servers in the USA and in Europe. You expressly consent to this storage.  
8.3. The texts you submit are used exclusively for creating the audio files and are only
visible to me as the Voice Artist.  
8.4. The created audio files are stored indefinitely and remain available for you to
download.  
8.5. You have the right to information, correction, deletion, and restriction of the
processing of your personal data at any time. Corresponding requests should be
directed to my contact email.
# 9. Copyright and Intellectual Property
9.1. The AI model for generating the voice is the intellectual property of CrispyVoice.  
9.2. The personality rights to my original voice remain with me as the Voice Artist.  
9.3. You acquire exclusively the usage rights to the generated audio file as defined in
Section 5.  
9.4. You are obligated to observe all applicable copyright and personality rights
provisions when using the audio files.  
# 10. Contract Duration and Termination
10.1. The contract between me as the Voice Artist and you ends with the provision of the
audio file; the usage rights continue in accordance with the conditions specified in
Section 5.  
10.2. I am entitled to revoke the usage rights with immediate effect if you violate these
GTC, especially if the audio files are used for illegal or defamatory purposes.
# 11. Changes to the GTC
11.1. I reserve the right to change these GTC at any time. Changes will be communicated
to you via email or through the newsletter.  
11.2. You will be informed about changes to the voice model or terms of use via
newsletter if you have subscribed to it.  
11.3. For already purchased audio files, the GTC valid at the time of purchase apply.
# 12. Dispute Resolution
12.1. In the event of disputes arising from or in connection with this contract, we commit
to first seeking an amicable solution. Please direct complaints and claims directly to me
as the Voice Artist using the provided contact email.  
12.2. I will respond to your complaint within 14 days and propose a solution.  
12.3. If no agreement can be reached, mediation according to the rules of the Swiss
Chamber of Commercial Mediation (SCCM) or the Swiss Federation for Mediation (SFM)
may be conducted before pursuing legal action. The costs of mediation shall be borne
equally by both parties unless otherwise agreed.  
# 13. Final Provisions
13.1. Should individual provisions of these GTC be or become invalid, the validity of the
remaining provisions shall remain unaffected.  
13.2. The law of the country in which I as the Voice Artist have my residence applies
exclusively, excluding the UN Convention on Contracts for the International Sale of
Goods.  
13.3. The place of jurisdiction for all disputes arising from or in connection with these
GTC is my residence as the Voice Artist, to the extent legally permissible.  
13.4. These GTC were last updated on [01.05.2025].`
    }
};
